import{gql as e}from"@apollo/client";const o=e`
  mutation AddFeedbackRadioOnCheckbox($questionAnswerId: Int!, $radioResponseId: Int!, $snippetSummaryId: Int!, $checkboxResponseId: Int!) {
    summaryFeedback {
      addFeedbackRadioCheckbox(
        questionAnswerId: $questionAnswerId
        radioResponseId: $radioResponseId
        contentSnippetSummaryId: $snippetSummaryId
        checkboxResponseId: $checkboxResponseId
      )
    }
  }
`;export{o as ADD_FEEDBACK_RADIO_ON_CHECKBOX};
//# sourceMappingURL=SummaryFeedbackConfigurationMultiResponseText.graphql.js.map
